const InitialState = {
  hasSetup: null,
  company_name: null,
  about_us: null,
  language_id: null,
  circuits: [],
  tradeLists: [],
  type: null,
  exchange_id: null,
  ticker_symbol: null,
  industry_id: null,
  city: null,
  state: null,
  country_id: null,
  website: null,
  related_links: null,
  release_tags: null,
  logo: {
    caption: null,
    copyRight: null,
    base64: null,
    fileName: null,
    fileType: null,
    languageId: null,
    title: null,
  },
  boilerplate: {
    language_id: null,
    circuits: null,
    tradeLists: null,
    about_us: null,
    logoB64: null,
  },
};

const mutations = {
  setHasSetup(state, value) { return Object.assign(state, { hasSetup: value }); },
  setCompanyName(state, value) { return Object.assign(state, { company_name: value }); },
  setAboutUs(state, value) { return Object.assign(state, { about_us: value }); },
  setLanguageId(state, value) { return Object.assign(state, { language_id: value }); },
  setCircuits(state, value) { return Object.assign(state, { circuits: value }); },
  setTradeLists(state, value) { return Object.assign(state, { tradeLists: value }); },
  setType(state, value) { return Object.assign(state, { type: value }); },
  setExchangeId(state, value) { return Object.assign(state, { exchange_id: value }); },
  setTickerSymbol(state, value) { return Object.assign(state, { ticker_symbol: value }); },
  setIndustryId(state, value) { return Object.assign(state, { industry_id: value }); },
  setCity(state, value) { return Object.assign(state, { city: value }); },
  setState(state, value) { return Object.assign(state, { state: value }); },
  setCountryId(state, value) { return Object.assign(state, { country_id: value }); },
  setWebsite(state, value) { return Object.assign(state, { website: value }); },
  setLogo(state, value) { return Object.assign(state, { logo: value }); },
  setBoilerplate(state, value) { return Object.assign(state, { boilerplate: value }); },
};

const actions = {
  setDefaultValues({ commit }, payload) {
    const boilerPlate = {
      language_id: payload.language_id,
      circuits: payload.circuits,
      tradeLists: payload.tradeLists,
      about_us: payload.about_us,
      related_links: payload.related_links,
      release_tags: payload.release_tags,
    };
    commit('setBoilerplate', boilerPlate);
  },
};

const getters = {
  hasSetup: (state) => state.hasSetup,
  company_name: (state) => state.company_name,
  about_us: (state) => state.about_us,
  language_id: (state) => state.language_id,
  circuits: (state) => state.circuits,
  tradeLists: (state) => state.tradeLis,
  type: (state) => state.type,
  exchange_id: (state) => state.exchange_id,
  ticker_symbol: (state) => state.ticker_symbol,
  industry_id: (state) => state.industry_id,
  city: (state) => state.city,
  state: (state) => state.state,
  country_id: (state) => state.country_id,
  website: (state) => state.website,
  logo: (state) => state.logo,
  boilerplate: (state) => state.boilerplate,
};

export default {
  state: InitialState,
  mutations,
  actions,
  getters,
  namespaced: true,
};
